import { render } from "./Wheel.vue?vue&type=template&id=1c33f088"
import script from "./Wheel.vue?vue&type=script&lang=js"
export * from "./Wheel.vue?vue&type=script&lang=js"

import "./Wheel.vue?vue&type=style&index=0&id=1c33f088&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__